import { useCallback, useEffect, useState } from 'react'
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
  SubMenu,
} from 'react-pro-sidebar'

import { Link, useLocation } from 'react-router-dom'

import { Image } from 'react-bootstrap'

import Logo from '../../assets/Logo.png'

import './custom.scss'
import ProfileInfo from '../ProfileInfo'
import { isSmallDevice } from '../../utils/deviceScreen'

function Sidebar({ menu, toggled, collapsed, handleToggleSidebar, user }) {
  const { pathname } = useLocation()

  const [isSmallWidth, setIsSmallWidth] = useState(() => {
    const checkScreenWidth = isSmallDevice()

    return checkScreenWidth
  })

  const updateShowProfileInfo = useCallback(() => {
    const checkScreenWidth = isSmallDevice()
    setIsSmallWidth(checkScreenWidth)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateShowProfileInfo)
    return () => {
      window.removeEventListener('resize', updateShowProfileInfo)
    }
  })

  const isActive = (route) => {
    return pathname.includes(route) && route !== '/'
  }
  return (
    <div style={{ minHeight: '100vh' }}>
      <ProSidebar
        collapsed={collapsed}
        toggled={toggled}
        breakPoint="sm"
        onToggle={handleToggleSidebar}
      >
        <SidebarHeader
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: 16,
            paddingTop: 50,
            paddingBottom: 25,
            position: 'sticky',
            top: 0,
          }}
        >
          <Image fluid={'true'} width={130} src={Logo} />
          {user && (user.name || user.brand_name) && isSmallWidth && (
            <div
              style={{
                paddingTop: 25,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 12,
              }}
            >
              <div style={{ maxWidth: 120 }}>
                Olá, {user.name ? user.name.split(' ')[0] : user.brand_name.split(' ')[0]}
              </div>
              <ProfileInfo user={user} />
            </div>
          )}
        </SidebarHeader>
        <SidebarContent style={{ zIndex: -1 }}>
          <Menu iconShape="square">
            {menu.map((m, m_index) =>
              m.subitems && m.subitems.length ? (
                <SubMenu
                  key={'menu_' + m_index}
                  title={m.name}
                  icon={m.icon}
                  defaultOpen={pathname.includes(m.route)}
                >
                  {m.subitems.map((s, index) => (
                    <MenuItem
                      key={`item_${index}_submenu_${m_index} `}
                      style={{
                        backgroundColor: isActive(s.route) && 'rgba(128, 128, 128, 0.6)',
                        color: isActive(s.route) && '#053c5e',
                        fontWeight: isActive(s.route) ? 600 : 400,
                        borderRadius: 12,
                      }}
                      title={s.name}
                      active={isActive(s.route)}
                      icon={s.icon}
                    >
                      {s.name}
                      <Link to={s.route} />
                    </MenuItem>
                  ))}
                </SubMenu>
              ) : (
                <MenuItem
                  key={'menu_' + m_index}
                  style={{
                    backgroundColor: isActive(m.route) && 'rgba(128, 128, 128, 0.6)',
                    color: isActive(m.route) && '#053c5e',
                    fontWeight: isActive(m.route) ? 600 : 400,
                    borderRadius: 12,
                  }}
                  title={m.name}
                  active={isActive(m.route)}
                  icon={m.icon}
                >
                  {m.name}
                  <Link to={m.route} />
                </MenuItem>
              ),
            )}
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </div>
  )
}

export default Sidebar
